/*
 * @Descripttion: 
 * @Author: zhongbin.chen
 * @Date: 2021-12-18 10:32:53
 */

import https from '@/utils/https'
import { RequestParams, ContentType, Method } from 'axios-mapper'


// 消杀记录列表
export const disinfectList = (params: any) => {
	return https().request('robohub/robohub-disinfect-list', Method.POST, params, ContentType.json)	
}
// 进出仓记录列表
export const warehouseList = (params: any) => {
	return https().request('robohub/robohub-in-out-list', Method.POST, params, ContentType.json)	
}
// 消毒仓序列号列表
export const robohubSnList = (params: any) => {
	return https().request('robohub/robohubSn-list',  Method.GET, params, ContentType.form)
}
// 被消杀设备序号列表
export const snList = (params: any) => {
	return https().request('robohub/sn-list',  Method.GET, params, ContentType.form)
}
// ADIBOT
export const adibotList = (params: any) => {
	return https().request('adibot/adibotinfo-list',  Method.GET, params, ContentType.form)
}
// 机器人列表
export const robotList_adibot = (params: any) => {
	return https().request('adibot/adibot-list',  Method.GET, params, ContentType.form)
}
// care获取所有目的地
export const disinfectPlace_adibot = (params: any) => {
	return https().request('building/all',  Method.GET, params, ContentType.form)
}
// Rainbot
export const rainbotList = (params: any) => {
	return https().request('RainbotTask/list', Method.GET, params, ContentType.form)
}
// 机器人列表
export const robotSnList = (params: any) => {
	return https().request('RainbotTask/robotSnList',  Method.GET, params, ContentType.form)
}
// 任务地点列表
export const taskLocation = (params: any) => {
	return https().request('RainbotTask/taskLocation',  Method.GET, params, ContentType.form)
}
// Carbot
export const carbotList = (params: any) => {
	return https().request('carbotTask/list', Method.GET, params, ContentType.form)
}
// 机器人列表
export const robotSnList_c = (params: any) => {
	return https().request('carbotTask/robotSnList',  Method.GET, params, ContentType.form)
}
// 任务地点列表
export const taskLocation_c = (params: any) => {
	return https().request('carbotTask/taskLocation',  Method.GET, params, ContentType.form)
}